export default "__VITE_ASSET__79caeb17__"